import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';  
import Main from './pages/Dashboard/Dashboard'; 
import LandingPage from './pages/Landing Page/LandingPagevgood'; 
import PrivacyPolicy from './pages/Privacy/PrivacyPolicy';  
import TermsAndCondition from './pages/Terms/TermsAndCondition';  
import Refund from './pages/Refund/Refundpolicy';
import Blogs from './pages/Blogs/Blogs';
import Blogpage from './pages/Blogs/Blogpage';
import NotFoundPage from './pages/404/NotFoundPage';
import Generatepage from "./pages/Result/Generatepage";
import Buypremium from './pages/Subscription/Buypremium';
import EditPage from './pages/Edit page/EditPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PreviewPage from "./pages/Edit page/PreviewPage";
import { 
  trackPageView, 
  trackEvent, 
  trackSessionStart, 
  trackSessionEnd 
} from './utils/analyticsService';
import SubscriptionHandler from './components/SubscriptionHandler';

function App() {
  const location = useLocation();

  // Track page views + time on page
  useEffect(() => {
    // Track page view
    trackPageView(location.pathname);

    // Start timer for time on page
    const startTime = Date.now();

    return () => {
      // When component unmounts (route changes), track time on previous page
      const duration = Date.now() - startTime; // in ms

      trackEvent('time_on_page', {
        page_path: location.pathname,
        duration_seconds: Math.round(duration / 1000)
      });
    };
  }, [location]);

  // Track JS errors
  useEffect(() => {
    const handleError = (event) => {
      trackEvent('js_error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno
      });
    };

    const handlePromiseRejection = (event) => {
      trackEvent('unhandled_promise_rejection', {
        reason: event.reason
      });
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handlePromiseRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handlePromiseRejection);
    };
  }, []);

  // Track session start + returning user + session end
  useEffect(() => {
    // Returning user vs new user
    const isReturningUser = localStorage.getItem('isReturningUser');

    if (isReturningUser) {
      trackEvent('returning_user', {
        timestamp: Date.now()
      });
    } else {
      trackEvent('new_user', {
        timestamp: Date.now()
      });
      localStorage.setItem('isReturningUser', 'true');
    }

    // Session start
    trackSessionStart();

    const handleSessionEnd = () => {
      trackSessionEnd();
    };

    window.addEventListener('beforeunload', handleSessionEnd);

    return () => {
      window.removeEventListener('beforeunload', handleSessionEnd);
    };
  }, []);

  return (
    <>   
     {/* ✅ GLOBAL TOASTS – visible on all pages */}
    <ToastContainer
      position="top-right"
      autoClose={3000}
      newestOnTop
      closeOnClick
      pauseOnHover
      style={{ zIndex: 99999 }} /* <-- Add this single line */
    />
    
     <Routes>
      <Route path="/" element={<LandingPage />} />  
      <Route path="/Dashboard" element={<Main />} />  
      <Route path="/premium" element={<Buypremium />} />  
      <Route path="/subscription-handler" element={<SubscriptionHandler />} />
      <Route path="/result" element={<Generatepage />} />  
      <Route path="/privacy" element={<PrivacyPolicy />} />  
      <Route path="/terms&condition" element={<TermsAndCondition />} />  
      <Route path="/refundpolicy" element={<Refund />} />  
      <Route path="/blog" element={<Blogs />} />
      <Route path="/blog/:title" element={<Blogpage />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/edit" element={<EditPage />} />
      <Route path="/preview" element={<PreviewPage />} />
      {/* <Route path="/secret-test" element={<SecretTestPage />} /> */}
    </Routes>
    </>

  );
}

export default App;
